import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-common-electricity",
  "use": "svg-icon-common-electricity-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"svg-icon-common-electricity\"><path fill=\"#ffc520\" d=\"M55.62 28.732a2.185 2.185 0 00-3.884-1.374l-17.77 21.954a2.184 2.184 0 001.696 3.558h8.717v18.4a2.18 2.18 0 003.875 1.373l17.78-21.966a2.18 2.18 0 00-1.695-3.553h-8.72z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol